export default {"src":"/_next/static/media/title-arrow.e5de1241.svg","height":27,"width":196,"blurWidth":0,"blurHeight":0};